export const MAX_HOTEL_ADULT = 6;
export const MAX_TRANSPORT_ADULT = 9;
